import Vue from 'vue'
import Router from 'vue-router'
import routeName from '@/router/routeNames'
import Page404 from '@/pages/Page404'
import PG_Login from '@/pages/Login'
import PG_Home from '../containers/DefaultContainer'
import PG_CompetentAuthorities from '@/views/compententAuthorities/list/Index'
import PG_User from '@/views/user/Index'
import PG_UserList from '@/views/user/list/Index'
import PG_Recommendations from '@/views/recommendations/list/Index'
import PG_PublicRecommendations from '@/pages/public/Recommendations.vue'
import store from '@/store/store'
import * as r_permission from '@/shared/route_permission'

Vue.use(Router)

const router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: function (to) {
        if (to.hash) {
            return {selector: to.hash, offset: {y: 100}}
        } else {
            return {y: 0}
        }
    },
    routes: [
      {path: '/public-recommendations', name: routeName.RN_PUBLIC_RECOMMENDATION_LIST, component: PG_PublicRecommendations},
      {path: '/login', name: routeName.RN_LOGIN, component: PG_Login},
      {
        path: '/',
        redirect: '/recommendations',
        name: routeName.RN_HOME,
        component: PG_Home,
        children: [
          {
            path: 'recommendations',
            name: routeName.RN_RECOMMENDATION_LIST,
            component: PG_Recommendations,
            meta: {

            },
          },
          {
            path: 'user-settings',
            name: routeName.RN_USER_SETTINGS,
            component: PG_User,
          },
          {
            path: 'competent-authorities',
            name: routeName.RN_COMPETENT_AUTHORITIES,
            component: PG_CompetentAuthorities,
            meta:{
              t:"INSTITUTIONS",
              permission_id: r_permission.R_COMPETENT_AUTHORITIES
            }
          },
          {
            path:'users',
            name:routeName.RN_USER_LIST,
            component:PG_UserList,
            meta:{
              permission_id: r_permission.R_USERS,
              t:"USERS"
            }
          }
          ]
      },
      // last route, replace with 404 page
      {path: '*', component: Page404},

]
})

router.beforeEach((to, from, next) => {

  if (typeof to.meta.permission_id === 'undefined') {
    next()
  } else {
    if (store.getters['user/getPermission'](to.meta.permission_id)) {
      next()
    } else {
      next({name: routeName.RN_LOGIN})
    }
  }
})

export default router
